import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import http from 'services/http';
import ListaResponsiva from 'components/Usuarios/Lista';

export default function SubAdmin() {
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtro, setFiltro] = useState('');

    useEffect(() => { buscarUsuarios(); }, []);

    async function buscarUsuarios() {
        try {
            setLoading(true);
            const res = await http.get('/usuarios', { params: { nivel: 'subadmin' } });
            setUsuarios(res.data.data);
        } catch {
            toast.error('Erro ao buscar usuários.');
        } finally {
            setLoading(false);
        }
    }

    async function alterarStatus(id, ativo) {
        try {
            await http.patch(`/usuarios/${id}/status`, { status: !ativo });
            setUsuarios(prev => prev.map(u => u.id === id ? { ...u, ativo: !u.ativo } : u));
        } catch {
            toast.error('Erro ao alterar status.');
        }
    }

    const usuariosFiltrados = usuarios.filter(u =>
        u.login.toLowerCase().includes(filtro.toLowerCase())
    );

    return (
        <>
            <div className="titulo-principal">Sub Admin</div>

            <div className="conteudo-principal d-flex duas-colunas">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Filtrar por nome"
                    onChange={e => setFiltro(e.target.value)}
                />
                <Link className="btn btn-info" to="/usuarios/criar/subadmin">
                    Novo Sub Admin
                </Link>
            </div>

            {loading ? (
                <div className="loader" />
            ) : (
                <div className="m-t">
                    <ListaResponsiva
                        tBody={usuariosFiltrados}
                        nivel="subadmin"
                        showButton1={true}
                        showButton2={true}
                        tButton2={alterarStatus}
                    />
                </div>
            )}
        </>
    );
}
